import { RootState } from '€slices/types';

export const getSigningUp = (state: RootState) => state.signUp.signingUp;
export const getSignUpSuccess = (state: RootState) => state.signUp.signUpSuccess;
export const getSignUpFailed = (state: RootState) => state.signUp.signUpFailed;
export const getSignUpError = (state: RootState) => state.signUp.signUpError;
export const getSignUpTokenValidationState = (state: RootState) =>
    state.signUp.regTokenValidateState;
export const getSignUpTokenData = (state: RootState) => state.signUp.regTokenData;
